export const getLimitQueryString = (limit: number) => `limit=${limit}`;
